module["exports"] = ["########", "## ## ## ##", "### ## ###", "+47 ## ## ## ##"];